import { Http } from '../../../support';

export const initialState = {
  busy: false,
  data: {
    tipo: 'xml',
  },
  progress: 0,
  result: undefined,
  error: undefined,
};

const reset = (store, data) => {
  store.setState((state) => {
    state.modulo.recepcion.upload = { ...initialState };
  });
};

const onChange = (store, data) => {
  store.setState((state) => {
    state.modulo.recepcion.upload.data = {
      ...state.modulo.recepcion.upload.data,
      ...data,
    };
  });
};

const progress = (store, progress) => {
  store.setState((state) => {
    state.modulo.recepcion.upload.progress = progress;
  });
};

const upload = async (store, onUploadProgress = () => {}) => {
  store.setState((state) => {
    state.modulo.recepcion.upload.busy = true;
  });

  try {
    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    };

    const { data } = store.state.modulo.recepcion.upload;

    let formData = new FormData();

    formData.append('files[]', data.file);
    formData.append('type', data.tipo);

    const response = await Http.post(`${window.BONJOUR_URL}/api/recepciones`, formData, options);

    store.setState((state) => {
      state.modulo.recepcion.upload.busy = false;
      state.modulo.recepcion.upload.progress = 100;
      state.modulo.recepcion.upload.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.recepcion.upload.busy = false;
      state.modulo.recepcion.upload.error = error.data || error;
    });
  }
};

const RecepcionUploadStore = {
  state: () => initialState,
  actions: {
    reset,
    onChange,
    progress,
    upload,
  },
};

export default RecepcionUploadStore;
